import { usePrivilege } from "../../../../../components/priviledge/PriviledgeProvider";
import { Contract } from "../../../../../type/entities/contract-type";
import { fixNumber } from "../../../../../utils/formatNumber";
import { formatInfoValue, InfoCard, InfoField, InfoGroup, InfoTagList } from "./components/InfoDisplay";

interface ProductContractFormInfoProps {
    data: Contract;
}

const ProductContractFormInfo = ({ data }: ProductContractFormInfoProps) => {
    const { userCan } = usePrivilege();
    const canAdminComplements = userCan("admin_complements", "complements");

    const productTypeName = data?.productType?.name ?? "";
    const isCursoBonificado = productTypeName === "CursoBonificado" || productTypeName === "Bonificada";

    const complementTags = Array.isArray(data?.complements)
        ? data.complements.map((complement: any, index: number) => {
            const name = complement?.complements?.name ?? complement?.name ?? `Complemento ${index + 1}`;
            const amount = complement?.amount != null ? ` (${fixNumber(Number(complement.amount))}€)` : "";
            return `${name}${amount}`;
        })
        : [];

    return (
        <InfoCard title="Datos del Producto" subtitle="Producto y condiciones económicas asociadas al contrato.">
            <InfoGroup title="Información General" description="Detalle del producto principal contratado.">
                <InfoField label="Tipo de producto" value={formatInfoValue(data?.productType?.name)} className="md:col-span-3" />
                <InfoField label="Producto" value={formatInfoValue(data?.product?.name)} className="md:col-span-5" />
                <InfoField
                    label="Importe"
                    value={data?.productAmount != null ? `${fixNumber(Number(data.productAmount))}€` : "N/A"}
                    className="md:col-span-2"
                />

                {isCursoBonificado && (
                    <InfoField
                        label="Código FUNDAE"
                        value={formatInfoValue(data?.product?.code)}
                        className="md:col-span-3"
                    />
                )}
            </InfoGroup>

            {canAdminComplements && (
                <InfoGroup title="Complementos" description="Servicios complementarios vinculados al producto.">
                    <InfoTagList label="Complementos seleccionados" items={complementTags} />
                </InfoGroup>
            )}

            <div className="flex justify-end">
                <div className="rounded-xl border border-primary/20 bg-primary/10 px-4 py-2 text-sm font-semibold text-primary">
                    Total contrato: {fixNumber(Number(data?.totalAmount ?? 0))}€
                </div>
            </div>
        </InfoCard>
    );
};

export default ProductContractFormInfo;
